import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { TaxRate } from '../../../../../common/models/tax-rate';

export const TAXRATES_REQUEST = 'TAXRATES_REQUEST';
export const TAXRATES_RECEIVED = 'TAXRATES_RECEIVED';
export const TAXRATES_ALL_RECEIVED = 'TAXRATES_ALL_RECEIVED';
export const TAXRATES_FAILED = 'TAXRATES_FAILED';
export const TAXRATE_DELETE = 'TAXRATE_DELETE';
export const TAXRATE_UPDATE = 'TAXRATE_UPDATE';
export const TAXRATE_CREATE = 'TAXRATE_CREATE';
export const TAXRATE_CREATED = 'TAXRATE_CREATED';

const receivedTaxRates = (taxRates: PaginatedResponse<TaxRate>) => {
    return {
        type: TAXRATES_RECEIVED,
        taxRates,
    };
};

const createdTaxRate = (taxRate: TaxRate) => {
    return {
        type: TAXRATE_CREATED,
        taxRate,
    };
};

export const fetchTaxRates = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: TAXRATES_REQUEST });

        const response = await api.taxRates.cget(searchParams);

        if (response.success) {
            dispatch(receivedTaxRates(response.result));
        } else {
            dispatch({ type: TAXRATES_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchAllTaxRates = () => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: TAXRATES_REQUEST });

        const response = await api.taxRates.cgetAll();

        if (response.success) {
            dispatch({ type: TAXRATES_ALL_RECEIVED, taxRates: response.result });
        } else {
            dispatch({ type: TAXRATES_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const deleteTaxRate = (taxRateId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.taxRates.deleteTaxRate(taxRateId);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.taxRateDeleted')));
            dispatch({ type: TAXRATE_DELETE, taxRateId });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const updateTaxRate = (taxRate: TaxRate) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: TAXRATE_UPDATE, taxRate });
        const response = await api.taxRates.updateTaxRate(taxRate);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.taxRateUpdated')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const createTaxRate = (taxRate: Partial<TaxRate>) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: TAXRATE_CREATE });
        const response = await api.taxRates.createTaxRate(taxRate);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.taxRateCreated')));
            dispatch(createdTaxRate(response.result));
        } else {
            dispatch({ type: TAXRATES_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
